var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconViewListRack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0837 13.75H5.91699C4.66699 13.75 4.16699 14.2833 4.16699 15.6083V18.975C4.16699 20.3 4.66699 20.8333 5.91699 20.8333H19.0837C20.3337 20.8333 20.8337 20.3 20.8337 18.975V15.6083C20.8337 14.2833 20.3337 13.75 19.0837 13.75Z",
    stroke: "#7E8299",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0837 4.16667H5.91699C4.66699 4.16667 4.16699 4.70001 4.16699 6.02501V9.39167C4.16699 10.7167 4.66699 11.25 5.91699 11.25H19.0837C20.3337 11.25 20.8337 10.7167 20.8337 9.39167V6.02501C20.8337 4.70001 20.3337 4.16667 19.0837 4.16667Z",
    stroke: "#7E8299",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViewListRack);
export default __webpack_public_path__ + "static/media/icon-view-list-rack.15ab1b86a5af12f563a50ff2200cfd50.svg";
export { ForwardRef as ReactComponent };